import { useContext } from 'react';

import { XYChartRectSelectionContext } from '../context/XYChartRectSelection.context.js';

export const useXYChartRectSelection = () => {
  const context = useContext(XYChartRectSelectionContext);
  if (!context) {
    throw new Error(
      'useXYChartRectSelection must be used within a XYChartRectSelectionProvider',
    );
  }

  return context;
};
